import { render, staticRenderFns } from "./InterpolationSettings.vue?vue&type=template&id=33a0b380&"
import script from "./InterpolationSettings.vue?vue&type=script&lang=js&"
export * from "./InterpolationSettings.vue?vue&type=script&lang=js&"
import style0 from "./InterpolationSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports